const CartDrawerReserve = {
  // Properties
  cartDrawerReserveBtn: null,
  rfqCartBtn: null,
  config: {
    cartDrawerReserveBtnSelector: "#data-cart-drawer-reserve",
    rfqCartBtnId: "rfq-btn-cart-0",
    errorDisplayDuration: 5000, // milliseconds
  },

  // Initialization method
  init() {
    try {
      this.findElements();
      this.attachEventListeners();
    } catch (error) {
      console.error("Initialization failed:", error);
      this.showErrorMessage(
        "Failed to initialize the cart drawer. Please refresh the page."
      );
    }
  },

  // Find and cache DOM elements
  findElements() {
    this.cartDrawerReserveBtn = document.querySelector(
      this.config.cartDrawerReserveBtnSelector
    );
    this.rfqCartBtn = document.getElementById(this.config.rfqCartBtnId);

    if (!this.cartDrawerReserveBtn) {
      throw new Error("CartDrawer-Reserve button not found");
    }
  },

  // Attach event listeners
  attachEventListeners() {
    if (this.cartDrawerReserveBtn) {
      this.cartDrawerReserveBtn.addEventListener(
        "click",
        this.handleReserveClick
      );
    }
  },

  // Handle the reserve button click
  handleReserveClick: (event) => {
    event.preventDefault();

    if (!CartDrawerReserve.rfqCartBtn) {
      CartDrawerReserve.rfqCartBtn = document.getElementById(
        CartDrawerReserve.config.rfqCartBtnId
      );
    }

    if (CartDrawerReserve.rfqCartBtn) {
      CartDrawerReserve.triggerRfqClick();
    } else {
      CartDrawerReserve.handleRfqButtonNotFound();
    }
  },

  // Trigger click on RFQ button
  triggerRfqClick() {
    try {
      this.rfqCartBtn.click();
    } catch (error) {
      console.error("Error triggering RFQ button click:", error);
      this.showErrorMessage(
        "An error occurred while processing your request. Please try again."
      );
    }
  },

  // Handle case when RFQ button is not found
  handleRfqButtonNotFound() {
    console.error("RFQ button not found");
    this.showErrorMessage(
      "Unable to process the request. The system may be temporarily unavailable."
    );
  },

  // Show error message
  showErrorMessage(message) {
    const errorContainer = this.createErrorContainer();
    errorContainer.textContent = message;
    document.body.appendChild(errorContainer);

    setTimeout(() => {
      errorContainer.remove();
    }, this.config.errorDisplayDuration);
  },

  // Create error container element
  createErrorContainer() {
    const errorContainer = document.createElement("div");
    errorContainer.style.cssText = `
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      background-color: #f8d7da;
      color: #721c24;
      padding: 10px 20px;
      border-radius: 5px;
      z-index: 9999;
      text-align: center;
    `;
    return errorContainer;
  },
};

const CartButtonManager = {
  rfqButtonId: "rfq-btn-cart-0",
  cartDrawerButtonId: "Cart-Reserve",
  rfqButton: null,
  cartDrawerButton: null,

  init: function () {
    // Initialize the object and set up event listeners
    this.findRfqButton()
      .then(() => {
        this.setupEventListeners();
        console.log("CartButtonManager initialized successfully");
      })
      .catch((error) => {
        console.error("Initialization failed:", error);
      });
  },

  findRfqButton: function () {
    return new Promise((resolve, reject) => {
      let attempts = 0;
      const maxAttempts = 20; // 20 seconds, checking every second

      const checkForButton = () => {
        this.rfqButton = document.getElementById(this.rfqButtonId);
        if (this.rfqButton) {
          resolve();
        } else if (attempts < maxAttempts) {
          attempts++;
          setTimeout(checkForButton, 1000); // Check again after 1 second
        } else {
          reject(new Error("RFQ button not found after 20 seconds"));
        }
      };

      checkForButton();
    });
  },

  setupEventListeners: function () {
    // Find the CartDrawer-Reserve button
    this.cartDrawerButton = document.getElementById(this.cartDrawerButtonId);

    if (this.cartDrawerButton) {
      this.cartDrawerButton.addEventListener(
        "click",
        this.handleCartDrawerClick.bind(this)
      );
    } else {
      console.warn("CartDrawer-Reserve button not found");
    }
  },

  handleCartDrawerClick: function (event) {
    event.preventDefault(); // Prevent default button behavior

    if (this.rfqButton) {
      // Trigger click on the RFQ button
      this.rfqButton.click();
    } else {
      console.error("RFQ button not available");
    }
  },
};

// Initialize the CartButtonManager
document.addEventListener("DOMContentLoaded", () => {
  CartButtonManager.init();
});
